import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-auth-listen',
  templateUrl: './auth-listen.component.html',
  styleUrls: ['./auth-listen.component.scss']
})
export class AuthListenComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
